export function toId(slug: string) {
  return slug.replace(/-/g, "_")
}

export function toSlug(id: string) {
  return id.replace(/_/g, "-")
}

// A market sector "id" is really a slug-like string, so we can use it directly in the URL
export function makeMarketSectorUrl(id: string) {
  return `/markets/${id}`
}
